export const evaluateCondition = (
  condition: any,
  currentValue: string | boolean | number | string[]
): boolean => {
  let threshold = condition.threshold;
  switch (condition.operator) {
    case '=':
      return currentValue === threshold;
    case '!=':
      return currentValue !== threshold;
    case 'Contains':
      return currentValue.toString().includes(threshold);
    case 'ContainsNot':
      return !currentValue.toString().includes(threshold);
    case '>':
      return isNaN(Number(currentValue))
        ? false
        : Number(currentValue) > Number(threshold);
    case '>=':
      return isNaN(Number(currentValue))
        ? false
        : Number(currentValue) >= Number(threshold);
    case '<':
      return isNaN(Number(currentValue))
        ? false
        : Number(currentValue) < Number(threshold);
    case '<=':
      return isNaN(Number(currentValue))
        ? false
        : Number(currentValue) <= Number(threshold);
    case 'True':
      return Boolean(currentValue);
    case 'False':
      return !Boolean(currentValue);
    case 'Checked':
      return (
        currentValue === true ||
        currentValue.toString().toLowerCase() === 'checked'
      );
    case 'Unchecked':
      return (
        currentValue === false ||
        currentValue.toString().toLowerCase() === 'unchecked'
      );
    case 'IncludedIn':
      const list = Array.isArray(threshold)
        ? threshold
        : threshold.trim().startsWith('[') && threshold.trim().endsWith(']')
        ? JSON.parse(threshold.replace(/'/g, '"'))
        : threshold.split(',').map((s: string) => s.trim());
      // MultiSelect stores its value as an array so at least one selected value must match
      if (Array.isArray(currentValue)) {
        return currentValue.some((val) => list.includes(val.toString()));
      }
      return list.includes(currentValue.toString());
  }
  return false;
};

export const parseQueryString = (
  queryString: string
): Record<string, string> => {
  const pairs = queryString.split('&');
  const result: Record<string, string> = {};
  pairs.forEach((pair) => {
    const [key, value] = pair.split('=');
    result[key] = value || '';
  });
  return result;
};

export const getUrlParameterValue = (
  uriParameter: string,
  parameterName?: string
): string | undefined => {
  if (!parameterName) return undefined;
  const currentParsedQueryString = parseQueryString(uriParameter);
  return currentParsedQueryString[parameterName];
};
